import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { RunMonitorPage } from '../../../../features/approvals/monitor/runs-page'
import { runMonitorSearchSchema } from '../../../../features/approvals/monitor/search'

export const Route = createFileRoute('/_app/workflows/runs/')({
  validateSearch: runMonitorSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'workflows.runs'),
  component: RunMonitorPage,
})
